// extracted by mini-css-extract-plugin
module.exports = {"root":"sidebar_root__1rIoH","primary":"sidebar_primary__lhWTv","secondary":"sidebar_secondary__2TvGi","button":"sidebar_button__kcjpU"};